export default __webpack_public_path__ + "static/media/ic-circle.45df2837.svg";